<div *ngIf="loading" class="loading">
  <mat-spinner></mat-spinner>
</div>
